"use client";
import { addReviewDisliked } from "@/utils/action/data";
import { ThumbsDown } from "lucide-react";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";

const AddDislike = ({ product, review, userData }) => {
  const session = useSession();
  const router = useRouter();
  const isExist = review?.dislikedBy?.includes(userData?._id);

  const handleLikeDislikeReview = async () => {
    if (!session?.data?.user?.email) {
      router.push("/login");
    }

    const reviewData = {
      userId: userData?._id,
      productId: product?._id,
      reviewId: review?._id,
    };

    const data = await addReviewDisliked(reviewData);

    if (data?.success) {
      window.location.reload();
    }
  };

  return (
    <div>
      {isExist}
      <ThumbsDown
        size={16}
        className={`cursor-pointer transition-colors ${
          isExist ? "text-destructive" : "text-muted-foreground hover:text-destructive"
        }`}
        strokeWidth={isExist ? 4 : 2}
        onClick={() => handleLikeDislikeReview(product._id, review._id, true)}
      />
    </div>
  );
};

export default AddDislike;